import React from 'react';
import { useParams } from 'react-router-dom';
import TaskManager from './TaskManager';

function TaskStatusManager() {
    const { status } = useParams();
    return (
        <TaskManager
            forcedStatus={status}
            isStatusView
        />
    );
}

export default TaskStatusManager;
